module.exports = __webpack_public_path__ + "static/media/13_Phone_IG.84b2095b.png";